
// Error Handling
import { NgModule } from '@angular/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

// Other
// import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// Modules
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { Title } from '@angular/platform-browser';
import APP_CONFIG from 'src/webpack/extra-webpack-types';
import { ErrorHandlerModule } from './modules/error-handler/error-handler.module';
import { getOrthoFiAuthProviders } from '@orthofi/auth-angular';
import type { OrthoFiEnvironment } from '@orthofi/auth-angular';

/**
 * The main application module containing the core module, shared module, and any feature modules.
 * initialized, the main application component will be created.
 */
@NgModule( {
  declarations: [
    AppComponent
  ],
  imports: [
    // Modules
    CoreModule,
    SharedModule,
    // Error Handling
    ErrorHandlerModule.forRoot(),
    // App Routing must be imported last
    AppRoutingModule
  ],
  providers: [
    Title,
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    { provide: 'ENV', useValue: APP_CONFIG },
    // Error Handling:
    { provide: 'ERROR_HANDLER_OPTIONS', useValue: APP_CONFIG.errorHandlerOptions },
    { provide: 'ERROR_LOGGER_OPTIONS', useValue: APP_CONFIG.errorLoggerOptions },
    // Other
    { provide: 'AUTHENTICATION_API',    useValue: APP_CONFIG.authenticationApi },
    { provide: 'PORTAL_URL',            useValue: APP_CONFIG.portalUrl },
    ...getOrthoFiAuthProviders({
      environment: APP_CONFIG.errorLoggerOptions.environment as OrthoFiEnvironment,
      isAnonymous: true,
      redirect: () => {
        window.location.replace(APP_CONFIG.errorHandlerOptions.authRedirectUrl);
      },
    }),
  ],
  bootstrap: [AppComponent]
} )
export class AppModule { }
